import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SatPopoverModule } from '@ncstate/sat-popover';
import { AgmCoreModule } from '@agm/core';
import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';

import { LandingPageComponent } from './landing-page/landing-page.component';
import { SharedModule } from '../shared/shared.module';
import { AppMaterialModule } from '../app-material.module';
import { AppRoutingModule } from '../routing/app-routing.module';
import { SearchFormComponent } from './search-form/search-form.component';
import { AirportResultsListingComponent } from './airport-results-listing/airport-results-listing.component';
import { ResultsMapComponent } from './results-map/results-map.component';
import { AirportFilterListComponent } from './airport-filter-list/airport-filter-list.component';
import { ActivityFilterListComponent } from './activity-filter-list/activity-filter-list.component';
import { CheckboxFilterComponent } from './checkbox-filter/checkbox-filter.component';
import { NumberFilterComponent } from './number-filter/number-filter.component';
import { SearchPageComponent } from './search-page/search-page.component';
import { FavoritesListComponent } from './favorites-list/favorites-list.component';
import { ActivityResultsListingComponent } from './activity-results-listing/activity-results-listing.component';
import { StateListingComponent } from './state-listing/state-listing.component';
import { StateAirportsComponent } from './state-airports/state-airports.component';
import { ProcDownloadComponent } from './proc-download/proc-download.component';
import { ProcSelectionTreeComponent } from './proc-selection-tree/proc-selection-tree.component';
import { EventResultsListingComponent } from './event-results-listing/event-results-listing.component';
import { EventFilterListComponent } from './event-filter-list/event-filter-list.component';
import { FavoriteEventsListComponent } from './favorite-events-list/favorite-events-list.component';
import { AnalyticsService } from '../airport/service/google-analytics-4.service';
import { FuelFilterListComponent } from './fuel-filter-list/fuel-filter-list.component';
// tslint:disable-next-line:max-line-length
import { FlyingClubFinderFilterListComponent } from './flying-club-finder-filter-list/flying-club-finder-filter-list.component';
// tslint:disable-next-line:max-line-length
import { FlyingClubFinderResultsListingComponent } from './flying-club-finder-results-listing/flying-club-finder-results-listing.component';
// tslint:disable-next-line:max-line-length
import { FlightSchoolFinderFilterListComponent } from './flight-school-finder-filter-list/flight-school-finder-filter-list.component';
// tslint:disable-next-line:max-line-length
import { FlightSchoolFinderResultsListingComponent } from './flight-school-finder-results-listing/flight-school-finder-results-listing.component';
// tslint:disable-next-line:max-line-length
import { UniversityFinderFilterListComponent } from './university-finder-filter-list/university-finder-filter-list.component';
// tslint:disable-next-line:max-line-length
import { UniversityFinderResultsListingComponent } from './university-finder-results-listing/university-finder-results-listing.component';
// tslint:disable-next-line:max-line-length
import { FboFinderFilterListComponent } from './fbo-finder-filter-list/fbo-finder-filter-list.component';
// tslint:disable-next-line:max-line-length
import { FboFinderResultsListingComponent } from './fbo-finder-results-listing/fbo-finder-results-listing.component';
// tslint:disable-next-line:max-line-length
import { ServiceRepairFinderFilterListComponent } from './service-repair-finder-filter-list/service-repair-finder-filter-list.component';
// tslint:disable-next-line:max-line-length
import { ServiceRepairFinderResultsListingComponent } from './service-repair-finder-results-listing/service-repair-finder-results-listing.component';
// tslint:disable-next-line:max-line-length
import { RentalSalesFinderFilterListComponent } from './rental-sales-finder-filter-list/rental-sales-finder-filter-list.component';
// tslint:disable-next-line:max-line-length
import { RentalSalesFinderResultsListingComponent } from './rental-sales-finder-results-listing/rental-sales-finder-results-listing.component';


@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    SatPopoverModule,
    AppRoutingModule,
    AppMaterialModule,
    AgmCoreModule,
    AgmSnazzyInfoWindowModule,
    SharedModule
  ],
  declarations: [
    LandingPageComponent,
    AirportResultsListingComponent,
    ResultsMapComponent,
    AirportFilterListComponent,
    ActivityFilterListComponent,
    CheckboxFilterComponent,
    NumberFilterComponent,
    SearchFormComponent,
    SearchPageComponent,
    FavoritesListComponent,
    ActivityResultsListingComponent,
    StateListingComponent,
    StateAirportsComponent,
    ProcDownloadComponent,
    ProcSelectionTreeComponent,
    EventResultsListingComponent,
    EventFilterListComponent,
    FavoriteEventsListComponent,
    FuelFilterListComponent,
    FlyingClubFinderFilterListComponent,
    FlyingClubFinderResultsListingComponent,
    FlightSchoolFinderFilterListComponent,
    FlightSchoolFinderResultsListingComponent,
    UniversityFinderFilterListComponent,
    UniversityFinderResultsListingComponent,
    FboFinderFilterListComponent,
    FboFinderResultsListingComponent,
    ServiceRepairFinderFilterListComponent,
    ServiceRepairFinderResultsListingComponent,
    RentalSalesFinderFilterListComponent,
    RentalSalesFinderResultsListingComponent
  ],
  providers: [
    AnalyticsService
  ],
  entryComponents: [
    ProcDownloadComponent
  ]
})
export class SearchModule { }
